import React, { memo, Suspense } from "react"
import Pages from "pages"
import Loading from "components/Loading"
import { useAuthContext } from "contexts/AuthContext"

const Layouts = () => {
  const { isLoading } = useAuthContext()

  return (
    <Suspense fallback={<Loading />}>
      {isLoading ? <Loading /> : <Pages />}
    </Suspense>
  )
}

export default memo(Layouts)
